var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDexscreener(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400.000000pt",
    height: "400.000000pt",
    viewBox: "0 0 360.000000 400.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "myGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#9f00ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(13, 240, 190)",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#myGradient)",
    d: "M1840 3575 c-217 -35 -389 -117 -561 -267 -47 -40 -62 -48 -81 -43 -57 18 -125 61 -174 110 -56 56 -57 50 -5 -52 38 -76 129 -198 219 -294 128 -137 370 -323 523 -403 l55 -29 60 29 c83 41 175 41 255 1 l56 -29 54 27 c272 137 630 472 745 698 51 100 50 105 -13 45 -59 -56 -114 -89 -167 -102 -24 -6 -35 0 -80 42 -85 80 -213 160 -329 206 -160 63 -391 89 -557 61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#myGradient)",
    d: "M1022 2908 c-80 -182 -83 -208 -93 -623 -4 -203 -13 -417 -19 -475 -25 -240 -98 -511 -190 -708 -27 -56 -47 -102 -44 -102 3 0 84 64 181 141 134 108 177 138 184 128 5 -8 63 -103 130 -211 l122 -198 136 129 c117 111 137 127 147 112 6 -9 104 -168 219 -354 114 -186 209 -336 210 -335 1 2 96 156 210 343 115 187 212 344 216 349 10 11 35 -9 165 -133 59 -55 110 -101 114 -101 5 0 61 87 126 193 64 105 122 198 128 204 9 10 49 -17 178 -121 92 -74 171 -137 176 -140 6 -3 -14 50 -44 119 -85 196 -144 412 -175 635 -6 47 -15 261 -19 475 -6 292 -12 406 -23 455 -19 80 -61 198 -95 265 l-25 50 -31 -39 c-17 -22 -57 -70 -88 -107 l-57 -66 27 -64 c22 -52 27 -80 27 -149 0 -73 -4 -92 -27 -135 -62 -119 -202 -204 -337 -205 l-33 0 7 -77 c4 -50 12 -82 21 -89 8 -7 84 -52 169 -100 84 -49 151 -92 149 -95 -2 -4 -68 -43 -146 -87 -173 -97 -186 -107 -242 -185 -96 -134 -184 -347 -285 -692 -83 -280 -88 -293 -94 -275 -4 8 -36 115 -71 237 -80 272 -143 447 -207 576 -94 188 -133 229 -336 342 -79 44 -143 83 -143 86 0 4 77 51 170 104 l170 98 0 56 c0 31 3 65 6 77 5 19 0 22 -54 27 -120 13 -224 68 -286 154 -72 100 -77 216 -15 370 12 30 11 33 -39 88 -28 31 -66 76 -83 101 -18 24 -36 44 -40 44 -4 0 -25 -42 -47 -92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#myGradient)",
    d: "M1376 2661 c-4 -6 -9 -32 -13 -59 -12 -105 77 -184 208 -184 55 0 124 16 142 32 5 4 -22 25 -60 45 -57 32 -178 110 -253 163 -12 9 -20 10 -24 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#myGradient)",
    d: "M2518 2601 c-53 -37 -130 -85 -170 -106 l-73 -39 44 -19 c29 -12 66 -19 112 -19 147 0 233 86 207 206 -5 25 -13 46 -16 45 -4 0 -51 -31 -104 -68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#myGradient)",
    d: "M1954 2479 c-50 -14 -120 -84 -153 -152 -34 -69 -51 -157 -51 -264 0 -83 -2 -85 -96 -138 l-68 -38 25 -19 c180 -138 250 -246 344 -528 l47 -140 49 146 c91 268 187 419 320 505 56 36 59 30 -44 88 -31 18 -62 41 -67 51 -6 10 -10 59 -10 107 0 184 -67 320 -185 374 -44 20 -64 22 -111 8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDexscreener);
export default __webpack_public_path__ + "static/media/dexscreener.61fbc20ce5bc2d0dcfd44fdc8916a802.svg";
export { ForwardRef as ReactComponent };